module.exports = __webpack_public_path__ + "img/4.e0135e0f.png";